import { EstadoSinPermiso } from '../../componentes/EstadoPagina';
import { Segmentos } from '../../componentes/Segmentos';
import { rolesDe } from '../../logica/acceso';
import { usePermisos } from '../../permisos/permisos';
import { rutaConApartado, type PropsPantalla } from '../tipos';
import { ParaDesarrolladores } from './ClavesApi';
import { Medicion } from './Medicion';
import { apartadosVisibles } from './reglas';
import { TuWeb } from './TuWeb';
import { Widgets } from './Widgets';
import '../../componentes/apartado.css';
import '../avisos/avisos.css';
import './web.css';

/**
 * «Web pública» (Configuración, entrada `web`, 13.1 a 13.6): la barra de apartados Tu web · Widgets · Medición en
 * `?apartado=`. La entrada llega con cualquiera de sus cuatro permisos (G628, G644, ADR-0175) y aquí solo se ven los apartados
 * que la persona puede ver: el Encargado y el Socio, solo «Medición» (sin barra, porque es uno solo). Las claves de API
 * (13.6) van plegadas al final de Widgets, en «Para desarrolladores»; `?apartado=api` las abre.
 */
const COMPONENTES = { web: TuWeb, widgets: Widgets, medicion: Medicion, api: SoloClaves } as const;

/** Las claves de API solas (G644): para quien tiene `api.claves.gestionar` sin `web.widgets.gestionar`. */
function SoloClaves(props: PropsPantalla) {
    return (
        <div className="rv-ca-apartado">
            <ParaDesarrolladores {...props} abrirAlEntrar />
        </div>
    );
}

export function Web(props: PropsPantalla) {
    const { busqueda, ruta, navegar, movil, membresia, nombreNegocio } = props;
    const { puede } = usePermisos();
    const apartados = apartadosVisibles(puede);
    // `?apartado=api` (la tarjeta «Para desarrolladores», G635) es Widgets con «Para desarrolladores» abierto (13.6).
    const pedido = busqueda.get('apartado') === 'api' && apartados.some((a) => a.valor === 'widgets') ? 'widgets' : busqueda.get('apartado');
    const activo = apartados.find((a) => a.valor === pedido) ?? apartados[0];

    if (activo === undefined) {
        return <EstadoSinPermiso seccion="Web pública" rol={membresia === undefined ? '' : rolesDe(membresia)} negocio={nombreNegocio} onInicio={() => { navegar('/'); }} movil={movil} />;
    }
    const Apartado = COMPONENTES[activo.valor];
    const base = ruta.split('?')[0] ?? ruta;

    return (
        <div className="rv-en-pantalla">
            {apartados.length > 1 && (
                <div className="rv-en-barra rv-wb-barra">
                    <Segmentos
                        etiqueta="Apartados de web pública"
                        movil={movil}
                        items={apartados.map((a) => ({ etiqueta: a.etiqueta, icono: a.icono }))}
                        valor={apartados.indexOf(activo)}
                        onCambio={(i) => {
                            const a = apartados[i];
                            if (a !== undefined) {
                                navegar(rutaConApartado(base, a.valor));
                            }
                        }}
                    />
                </div>
            )}
            <Apartado key={activo.valor} {...props} />
        </div>
    );
}
